import { BrowserRouter } from 'react-router-dom'
import { Providers } from './providers.tsx'
import { AppRoutes } from './router.tsx'

export function App() {
  return (
    <Providers>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Providers>
  )
}
